/* global gravityBlocksGlobalVars */
import './style.scss';

class DynamicBoxes {
    constructor(element) {
        this.block = element;
        this.filterId = element.dataset.filterId || null;
        this.paginationContainer = element.querySelector('.pagination'); // Container of both types numbers and load more
        this.pagination = element.querySelector('.gravity-block-dynamic-boxes__pagination');
        this.loadMore = element.querySelector('.gravity-block-dynamic-boxes__load-more-wrapper');
        this.results = element.querySelector('.posts-result__container');
        this.maxNumberPages = element.dataset.maxNumberPages || null;
        this.paged = 1;
    }

    init() {
        if (this.hasLoadMore) {
            this.initLoadMore();
        }

        if (this.hasPagination) {
            this.initPagination();
        }

        if (this.hasFilters) {
            this.initFilters();
        }
    }

    get hasLoadMore() {
        return this.loadMore !== null;
    }

    get hasPagination() {
        return this.pagination !== null;
    }

    get hasFilters() {
        return this.filterId !== null;
    }

    emitBoxesLoadedEvent() {
        const event = new CustomEvent('gg-boxes-loaded', {
            bubbles: true,
        });
        this.block.dispatchEvent(event);
    }

    initLoadMore() {
        this.loadMore.addEventListener('click', (event) => {
            event.preventDefault();

            this.loadMoreAjax();
        });
    }

    initPagination() {
        this.pagination.querySelectorAll('a').forEach((pageLink) => {
            pageLink.addEventListener('click', (event) => {
                event.preventDefault();

                this.paginationAjax(event.target);
            });
        });
    }

    initFilters() {
        const connectedFilter = document.querySelector(`.gravity-block-filters[data-filter-id="${this.filterId}"]`);

        if (connectedFilter) {
            connectedFilter.addEventListener('gg-filter-changed', (event) => {
                this.filterAjax(event.detail.filter);
            });
        }
    }

    loadMoreAjax() {
        this.paged++;

        this.postData({
            type: 'load-more',
        }).then((response) => {
            if (response.success && response.data.html) {
                this.results.innerHTML += response.data.html;

                if (this.paged >= this.maxNumberPages) {
                    this.loadMore.remove();
                }
            }
            this.emitBoxesLoadedEvent();
        });
    }

    paginationAjax(item) {
        const paged = item.dataset.page || null;

        switch (paged) {
            case 'prev':
                if (this.paged <= 1) {
                    return;
                }

                this.paged--;
                break;
            case 'next':
                if (this.paged >= this.maxNumberPages) {
                    return;
                }

                this.paged++;
                break;
            default:
                this.paged = parseInt(paged, 10);
        }

        this.postData({
            type: 'pagination',
        }).then((response) => {
            if (response.success && response.data.html) {
                this.results.innerHTML = response.data.html;
                this.pagination.outerHTML = response.data.pagination;
                this.pagination = this.block.querySelector('.gravity-block-dynamic-boxes__pagination');

                this.initPagination();
                this.emitBoxesLoadedEvent();
            }
        });

        this.block.scrollIntoView();
    }

    filterAjax(filterSettings) {
        const postTypes = this.block.dataset.postTypes || null;
        const terms = this.block.dataset.terms || null;

        this.paged = 1;

        this.postData({
            type: 'filter',
            filterSettings: JSON.stringify(filterSettings),
            post_types: postTypes,
            terms,
        }).then((response) => {
            if (!response.success || !response.data.html) {
                return;
            }

            this.results.innerHTML = response.data.html;
            this.block.dataset.foundPost = response.data.foundPost;
            this.emitBoxesLoadedEvent();

            if (response.data.pagination) {
                switch (response.data.type) {
                    case 'load-more':
                        this.maxNumberPages = response.data.max;
                        this.paginationContainer.innerHTML = response.data.pagination;
                        this.loadMore = this.block.querySelector('.gravity-block-dynamic-boxes__load-more-wrapper');

                        this.initLoadMore();

                        break;
                    case 'numbers':
                        this.paginationContainer.innerHTML = response.data.pagination;
                        this.pagination = this.block.querySelector('.gravity-block-dynamic-boxes__pagination');
                        this.initPagination();
                        break;
                    default:
                }
                this.block.dataset.blockArgs = response.data.args;
            } else if (this.hasPagination || this.hasLoadMore) {
                this.paginationContainer.innerHTML = '';
            }
        });
    }

    async postData(data = {}) {
        const blockArgs = this.block.dataset.blockArgs || null;
        const blockSettings = this.block.dataset.blockSettings || null;
        const formData = new FormData();

        formData.append('action', 'filter_dynamic_box');
        formData.append('nonce', gravityBlocksGlobalVars.nonce);
        formData.append('blockArgs', blockArgs);
        formData.append('blockSettings', blockSettings);
        formData.append('paged', this.paged);
        formData.append('post_id', gravityBlocksGlobalVars.postId);

        Object.entries(data).forEach((value) => {
            formData.append(value[0], value[1]);
        });

        const response = await fetch(gravityBlocksGlobalVars.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });

        return response.json();
    }
}

document.querySelectorAll('.gravity-block-dynamic-boxes').forEach((module) => {
    new DynamicBoxes(module).init();
});
